import { useEffect } from "react";
import { useDispatch, useSelector, useStore } from "react-redux";
import { toast } from "react-toastify";
import { signout } from "../actions";

// Timers pause while the computer sleeps, so re-check at least this often.
const MAX_CHECK_DELAY_MS = 60 * 1000;

const getTokenExpiry = (token) => {
    try {
        return JSON.parse(atob(token.split(".")[1])).exp * 1000;
    } catch {
        return NaN;
    }
};

function SessionExpiryWatcher() {
    const dispatch = useDispatch();
    const store = useStore();
    const accessToken = useSelector((state) => state.auth.token.access);

    useEffect(() => {
        if (!accessToken) return;

        let timer;
        const check = () => {
            clearTimeout(timer);
            // API requests send this copy, which another tab may have renewed or cleared.
            const msLeft = getTokenExpiry(localStorage.getItem("atoken")) - Date.now();

            if (msLeft > 0) {
                timer = setTimeout(check, Math.min(msLeft, MAX_CHECK_DELAY_MS));
            } else if (store.getState().auth.token.access) {
                toast.error("Session expired. Please login again.", {
                    toastId: "session-expired",
                });
                dispatch(signout());
            }
        };

        check();
        window.addEventListener("focus", check);
        document.addEventListener("visibilitychange", check);

        return () => {
            clearTimeout(timer);
            window.removeEventListener("focus", check);
            document.removeEventListener("visibilitychange", check);
        };
    }, [accessToken, dispatch, store]);

    return null;
}

export default SessionExpiryWatcher;
